import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Button, Grid, Form, Card, Icon} from 'semantic-ui-react';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {validDate} from 'common/utils';
import moment from 'moment';
import {
  TextAreaField,
  TextBoxField,
  InlineSelect,
  RadioField,
  DateBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import _ from 'lodash';
import {
  MITIGATION_PLAN_TYPES,
  MITIGATION_PLAN_TYPES_STANDARD_ENHANCED,
} from 'app-ui-componentlibrary/dist/common/constants';
import {isRequired, maxLength, minLength} from 'go/components/rules/rules';

const MODALS = {
  CREATE: 'create',
  EDIT: 'edit',
  NONE: 'none',
};

export class MitigationPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: MODALS.NONE,
      mitigationPlan: false,
      selectedIndex: -1,
      planNameError: false,
      planTypeError: false,
      planOptionsError: false,
      planDateError: false,
      planDescriptionLengthError: false,
      planDescriptionRequiredError: false,
    };
  }

  planNameErrorMessage = 'Please enter a response';
  planTypeErrorMessage = 'Please enter a response';
  planOptionsErrorMessage = 'Please enter a response';
  planDateErrorMessage = 'You must enter a valid date';
  planDescriptionLengthErrorMessage = 'Your response must be 4000 characters or less';
  planDescriptionRequiredError = 'Please enter a response';

  validateName = (name) => {
    return isRequired()(name) && minLength(1)(name) && maxLength(100)(name);
  };
  validatePlanOptions = (options) => {
    return isRequired()(options);
  };
  validatePlanDescription = (options) => {
    return isRequired()(options);
  };
  validateDate = (date) => {
    var invalidFormat = !_.isUndefined(date) && _.includes(date, '-');
    return (
      validDate(date, 'MM/DD/YYYY') &&
      moment(date).isAfter('12/31/1999') &&
      moment(date).isBefore(moment())
    );
  };
  handlePlanNameOnBlur = () => {
    this.setState({
      planNameError: !this.validateName(this.state.mitigationPlan.planName),
    });
  };
  handlePlanTypeOnBlur = () => {
    this.setState({
      planTypeError: !this.validateName(this.state.mitigationPlan.planType),
    });
  };
  handlePlanOptionsOnBlur = () => {
    this.setState({
      planOptionsError: !this.validatePlanOptions(this.state.mitigationPlan.planOptions),
    });
  };
  handlePlanDateOnBlur = () => {
    if (!!this.state.mitigationPlan.planApprovedDate) {
      this.setState({
        planDateErrorMessage: 'You must enter a valid date',
        planDateError: !this.validateDate(this.state.mitigationPlan.planApprovedDate),
      });
    } else {
      this.setState({
        planDateErrorMessage: 'Please enter a response',
        planDateError: true,
      });
    }
  };
  handlePlanDescriptionOnBlur = () => {
    this.setState({
      planDescriptionLengthError: !maxLength(4000)(
        this.state.mitigationPlan.proposedActivityDescription
      ),
      planDescriptionRequiredError:
        this.props.proposedActivityRequired &&
        !this.validatePlanDescription(
          this.state.mitigationPlan.proposedActivityDescription
        ),
    });
  };

  validateProfile = () => {
    const {mitigationPlan} = this.state;
    let plan = this.getPlan();
    Promise.all([
      this.handlePlanNameOnBlur(),
      this.handlePlanTypeOnBlur(),
      this.handlePlanOptionsOnBlur(),
      this.handlePlanDateOnBlur(),
      this.props.proposedActivityRequired && this.handlePlanDescriptionOnBlur(),
    ]).then(() => {
      if (
        !this.state.planNameError &&
        !this.state.planTypeError &&
        (!this.state.planOptionsError || !mitigationPlan.isPlanTypeStandardOrEnhanced) &&
        !this.state.planDateError &&
        (!this.props.proposedActivityRequired ||
          !this.state.planDescriptionRequiredError) &&
        (!this.props.proposedActivityRequired || !this.state.planDescriptionLengthError)
      ) {
        this.updatePlan(mitigationPlan);
      }
    });
  };

  handleCreatePlanButton() {
    this.setState({
      openModal: MODALS.CREATE,
      mitigationPlan: {},
    });
  }

  getPlan = () => {
    const savedPlan = _.get(this.props, 'data.planDetail');
    return savedPlan;
  };

  updatePlan = (plan) => {
    const {entityDataPath, entityType, data, readOnly} = this.props;
    let included = plan;
    this.setState({
      openModal: MODALS.NONE,
    });
    // Reset planOption
    if (!included.isPlanTypeStandardOrEnhanced) {
      included.planOptions = null;
    }
    this.props.saveEntityData(entityDataPath, entityType, {
      ...data,
      planDetail: included,
    });
  };
  handleCancelAction = () => {
    this.setState({
      openModal: MODALS.NONE,
      planNameError: false,
      planTypeError: false,
      planOptionsError: false,
      planDateError: false,
      planDescriptionLengthError: false,
      planDescriptionRequiredError: false,
    });
  };

  renderCreatePlanModal() {
    let {mitigationPlan} = this.state;
    if (mitigationPlan) {
      return (
        <FemaGoModal
          title="Enter plan details"
          size="small"
          open={this.state.openModal === MODALS.CREATE}
          buttonText="Save plan details"
          confirmAction={(e) => {
            this.validateProfile();
          }}
          cancelAction={this.handleCancelAction}
        >
          <br />
          {this.renderPlanForm()}
        </FemaGoModal>
      );
    }
  }

  renderPlanForm = () => {
    const {mitigationPlan} = this.state;
    const {proposedActivityRequired} = this.props;
    const descriptionTitle = `Proposed activity description${
      proposedActivityRequired ? '' : ' (Optional)'
    }`;

    const handleInputChange = (e) => {
      const {name, value} = e.target;
      const newMitigationPlan = {...this.state.mitigationPlan, [name]: value};

      if (MITIGATION_PLAN_TYPES_STANDARD_ENHANCED.includes(newMitigationPlan.planType)) {
        newMitigationPlan.isPlanTypeStandardOrEnhanced = true;
      } else {
        newMitigationPlan.isPlanTypeStandardOrEnhanced = false;
      }

      this.setState((prevState) => ({
        ...prevState,
        mitigationPlan: newMitigationPlan,
      }));
    };

    return (
      <React.Fragment>
        <Form id="mitigationPlan-form">
          <TextBoxField
            title="Plan name"
            guidance="Plan name"
            id="planName"
            name="planName"
            value={mitigationPlan.planName}
            handleChange={handleInputChange}
            handleBlur={this.handlePlanNameOnBlur}
            displayError={this.state.planNameError}
            errorMessages={this.planNameErrorMessage}
          />
          <div className="padding-top" />
          <InlineSelect
            label="Plan type"
            id="planType"
            name="planType"
            options={
              this.props.planTypeOptions !== undefined
                ? this.props.planTypeOptions
                : MITIGATION_PLAN_TYPES
            }
            value={mitigationPlan.planType}
            handleChange={handleInputChange}
            handleBlur={this.handlePlanTypeOnBlur}
            displayError={this.state.planTypeError}
            errorMessages={this.planTypeErrorMessage}
          />
          <div className="padding-top" />
          {mitigationPlan.isPlanTypeStandardOrEnhanced && (
            <RadioField
              label="Is this plan type standard or enhanced?"
              id="planOptions"
              name="planOptions"
              value={mitigationPlan.planOptions}
              handleChange={handleInputChange}
              handleBlur={this.handlePlanOptionsOnBlur}
              displayError={this.state.planOptionsError}
              errorMessages={this.planOptionsErrorMessage}
              options={[
                {label: 'Standard', value: 'Standard'},
                {label: 'Enhanced', value: 'Enhanced'},
              ]}
            />
          )}
          <div className="padding-top" />
          <TextBoxField
            size="small"
            title="Plan approval date"
            guidance="Plan approval date (MM/DD/YYYY)"
            id="planApprovedDate"
            name="planApprovedDate"
            value={mitigationPlan.planApprovedDate}
            handleChange={handleInputChange}
            handleBlur={this.handlePlanDateOnBlur}
            displayError={this.state.planDateError}
            errorMessages={this.state.planDateErrorMessage}
          />
          <div className="padding-top" />
          <TextAreaField
            title={descriptionTitle}
            guidance={descriptionTitle}
            id="proposedActivityDescription"
            name="proposedActivityDescription"
            maxLength={4001}
            value={mitigationPlan.proposedActivityDescription}
            handleChange={handleInputChange}
            handleBlur={this.handlePlanDescriptionOnBlur}
            displayError={
              this.state.planDescriptionLengthError ||
              (this.props.proposedActivityRequired &&
                this.state.planDescriptionRequiredError)
            }
            errorMessages={
              this.state.planDescriptionLengthError
                ? this.planDescriptionLengthErrorMessage
                : this.planDescriptionRequiredError
            }
          />
        </Form>
      </React.Fragment>
    );
  };

  renderEditPlanModal() {
    const {mitigationPlan} = this.state;
    let plan = this.getPlan();
    return (
      <FemaGoModal
        title="Edit plan details"
        size="small"
        open={this.state.openModal === MODALS.EDIT}
        buttonText="Update plan details"
        confirmAction={() => {
          this.validateProfile();
        }}
        cancelAction={this.handleCancelAction}
      >
        {mitigationPlan ? this.renderPlanForm() : null}
      </FemaGoModal>
    );
  }

  render() {
    let plan = this.getPlan();
    let entityPageType = this.props.readOnly;
    return (
      <React.Fragment>
        {!plan ? (
          !entityPageType ? (
            <Grid.Column width={10}>
              <div className="questionText">Please provide plan information.</div>
              <Button
                basic
                primary
                href="#"
                id="enterPlan"
                title="Enter plan details"
                onClick={() => this.handleCreatePlanButton()}
              >
                + Enter plan details
              </Button>
            </Grid.Column>
          ) : (
            <div></div>
          )
        ) : (
          <div>
            <div className="questionText">Please provide plan detail</div>
            {plan && (
              <Card fluid key="1" id="mitigationPlan-details">
                <Grid celled="internally" fluid>
                  <Grid.Column width={14}>
                    <Grid columns={3}>
                      <Grid.Column width="5">
                        <strong>Plan name</strong>
                        <div>{plan.planName}</div>
                      </Grid.Column>
                      <Grid.Column width="5">
                        <strong>Plan type</strong>
                        <div>
                          {plan.planType}{' '}
                          {plan.isPlanTypeStandardOrEnhanced
                            ? `(${plan.planOptions})`
                            : null}
                        </div>
                      </Grid.Column>
                      <Grid.Column width="4">
                        <strong>Plan approval date</strong>
                        <div>{plan.planApprovedDate}</div>
                      </Grid.Column>
                    </Grid>
                    <Grid>
                      <Grid.Column>
                        <strong>Proposed activity description</strong>
                        <div>{plan.proposedActivityDescription}</div>
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                  {!this.props.readOnly ? (
                    <Grid.Column width={2}>
                      <Grid columns={4}>
                        <Grid.Column width="10">
                          <a
                            href={`#`}
                            id="editPlan"
                            onClick={() =>
                              this.setState({
                                mitigationPlan: plan,
                                selectedIndex: 1,
                                openModal: MODALS.EDIT,
                              })
                            }
                          >
                            <Icon name="pencil" />
                            Edit
                          </a>
                        </Grid.Column>
                      </Grid>
                    </Grid.Column>
                  ) : null}
                </Grid>
              </Card>
            )}
          </div>
        )}
        {this.renderCreatePlanModal()}
        {this.renderEditPlanModal()}
      </React.Fragment>
    );
  }
}

export default connectDynamic(MitigationPlan);
